import React from "react";
import { CheckCircle2 } from "lucide-react";

const highlights = [
  "11 years in commercial HVAC delivery",
  "6 years leading operations & contracts",
  "F-Gas Cat 1 · IOSH · Legionella (WH001) · Fire Marshal",
  "MHI Modules 3 & 4 · Refrigerant Handler",
  "700+ fire dampers surveyed & drop-tested",
  "£600k+ contracts delivered · term-time & shutdown windows",
];

const MeetStevie = () => {
  return (
    <section className="py-24 max-w-editorial mx-auto px-6 md:px-10 lg:px-12" id="meet-stevie">
      <div className="font-mono text-[11px] tracking-overline uppercase text-muted mb-6">
        [ Meet the founder ]
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-6 mb-8">
        <img
          src="/team/stevie-coles.jpg"
          alt="Stevie Coles — Founder & Director of HVAC Operations, Calmbreeze"
          className="w-[140px] h-[140px] rounded-full object-cover object-[center_15%] ring-2 ring-brand/10 shadow-sm flex-shrink-0"
          loading="lazy"
          decoding="async"
        />
        <div>
          <h2 className="font-display font-bold text-[2rem] md:text-[2.75rem] tracking-tightest leading-[1.05] mb-2">
            Stevie Coles
          </h2>
          <div className="font-mono text-[12px] tracking-wide uppercase text-brand">
            Founder &amp; Director of HVAC Operations
          </div>
          <a
            href="https://www.linkedin.com/in/stevie-coles-calmbreeze"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="stevie-linkedin"
            className="inline-flex items-center gap-1.5 mt-2 text-[13px] text-brand hover:text-accent transition-colors"
          >
            Connect on LinkedIn <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>

      <div className="max-w-3xl">
        <p className="text-[17px] text-muted-foreground leading-relaxed mb-5">
          Stevie founded Calmbreeze after a decade delivering commercial HVAC and compliance
          programmes across London&rsquo;s hospitals, universities, food-production sites and
          hospitality estates. He&rsquo;s spent his career at the sharp end of the trade &mdash;
          surveying fire dampers at St George&rsquo;s Hospital, replacing 60 metres of stainless
          duct on the Maltesers line inside a 10-day shutdown, and building the kind of asset
          registers auditors actually trust.
        </p>
        <p className="text-[17px] text-muted-foreground leading-relaxed mb-8">
          That combination &mdash; hands-on engineer plus operations lead &mdash; is what shapes
          how we work today: proactive, well-documented, and accountable to a single point of
          contact.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 pt-6 border-t border-black/8">
          {highlights.map((h, i) => (
            <div key={i} className="flex items-start gap-2 text-[14px] text-ink/85">
              <CheckCircle2 className="h-4 w-4 text-brand mt-0.5 flex-shrink-0" />
              <span>{h}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MeetStevie;
